import * as React from 'react';
import { FC, useEffect } from 'react';
import './Advantages.scss';
import { AdvantagesData } from '../types';
import DynamicSnake from '../DynamicSnake/DynamicSnake';
import DirectionArrow from '../DirectionArrow/DirectionArrow';

interface AdvantagesProps {
  data: AdvantagesData[];
  title?: string;
}

const Advantages: FC<AdvantagesProps> = ({ data, title = 'Why Lunka' }) => {
  useEffect(() => {
    const path = document.querySelector('#snake-path') as HTMLElement | any;
    const arrow = document.querySelector('#arrow-path') as HTMLElement | any;

    path.style.strokeDasharray = path.getTotalLength() as number;

    window.addEventListener('scroll', function () {
      const rectBottom = path.getBoundingClientRect().bottom;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollTop = document.documentElement.scrollTop;
      const scrollPercentage = scrollTop / (scrollHeight - clientHeight);
      const scrollToEnd = rectBottom - clientHeight * scrollPercentage <= 200;

      path.style.strokeDashoffset = rectBottom - 250 * -scrollPercentage;
      if (scrollToEnd) {
        arrow.style.opacity = 1;
        arrow.style.transition = '0.3s';
        path.style.strokeDashoffset = 0.1;
        path.style.transition = '0.2s';
      } else {
        arrow.style.opacity = 0;
        arrow.style.transition = '0s';
      }
    });
  }, []);

  return (
    <section className="advantages">
      <div className="advantages__container">
        <div className="advantages__head">
          <h2>{title}</h2>
        </div>
        <DynamicSnake svgId="snake-svg" pathId="snake-path" />
        <div className="advantages__offers">
          {data.map(({ step, number }, index: number) => {
            return (
              <div className="advantages__solution" key={index}>
                <span>{number}</span>
                <div className="solution_item">
                  <p>{step}</p>
                </div>
              </div>
            );
          })}
        </div>
        <DirectionArrow svgId="arrow-svg" pathId="arrow-path" />
      </div>
    </section>
  );
};

export default Advantages;
